import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Table,
  Spin,
  Select,
  DatePicker,
  Space,
  Form,
  message,
} from "antd";
import Button from "atoms/Button";
import moment from "moment";
import styled from "@emotion/styled";
import { CSVLink } from "react-csv";
import { connect } from "react-redux";
import {
  getUserRoleId,
  getSelectedDepartmentId,
  getStatusListFromID,
  getUserInfo,
  getLeaveCategoryList,
  getClientid,
  getUserList,
  getRoleList,
} from "redux/selectors";
import { bindActionCreators } from "redux";
import { toggleProcessingModal } from "redux/actions";
import { CALL_API } from "common/API";
import {
  MONTH_LIST,
  APPROVAL_FILTER_TYPES,
  STATUS_CODE,
} from "common/Constants";
import {
  addDaysinDate,
  dateInDetail,
  getMonthDateRange,
  getKenyanDateTime,
  addMonthinDate,
  getMySqlDate,
  momentDate,
  getinitialdate,
} from "utils/Date";
import COLORS from "common/Colors";
import {
  find,
  get,
  includes,
  reduce,
  concat,
  map,
  result,
  filter,
  intersection,
} from "lodash";
import ViewMore from "organisms/ViewMore";
import { ButtonOutlined } from "reusableComponent/UIButtons";
import { useTranslation } from "react-i18next";

const StyledTable = styled(Table)`
  padding-top: 20px;
  table {
    width: 100% !important;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
  .normal-column {
    min-width: 200px;
    white-space: normal;
  }
`;

const StyledApprovalSearchForm = styled(Form)`
  .ant-form-item-with-help {
    margin-bottom: 0px;
    .ant-form-item-explain-connected {
      display: none;
    }
  }
  .ant-form-item {
    display: inline-block;
  }
  .outer-form {
    margin-right: 0px;
  }
  .ant-select-selector {
    max-width: 200px;
    min-width: 180px;
    margin-bottom: 10px;
    width: 100%;
  }
`;

const StyledButton = styled(Button)`
  width: 120px;
  border: 1px solid ${COLORS.PRIMARY};
  color: ${COLORS.PRIMARY};
  width: initial;
  background: transparent;
  border-radius: 5px;
`;

function Myleavereport({
  userRoleId,
  statusListFromID,
  selectedDepartmentId,
  userInfo,
  leaveCategoryList,
  ClientId,
  userList,
  roleList,
}) {
  const { t } = useTranslation();

  const [leaveList, setLeaveList] = useState([]);
  const [CSVLeaveList, setCSVLeaveList] = useState([]);
  const [displayTaskLoader, setDisplayTaskLoader] = useState(false);
  const [leaveStatusId, setLeaveStatusId] = useState("4");
  const [CSVloader, setCSVLoader] = useState(false);
  const [form] = Form.useForm();
  const csvLinkEl = useRef();
  const containerRef = useRef(null);
  const [filterState, setFilterState] = useState({
    end_date: null,
    month: dateInDetail(getKenyanDateTime()).monthName,
    start_date: null,
    duration_type: 4,
    status_id: "4",
    leave_type: "",
  });

  const data = map(leaveList, ({ having_cancel_request }) => ({
    having_cancel_request,
  }));

  const data1 = leaveList?.filter((val) => {
    if (data === "") {
      return val;
    } else if (val?.status_name?.toLowerCase().includes("wait".toLowerCase())) {
      return val;
    } else if (
      val?.status_name?.toLowerCase().includes("Approved".toLowerCase())
    ) {
      if (
        JSON.stringify(val?.having_cancel_request)
          .toLowerCase()
          .includes("1".toLowerCase())
      ) {
        return val;
      }
    }
  });

  const CSVHeaders = [
    { label: t("Leave Type"), key: "leave_category_name" },
    { label: t("Start Date"), key: "start_date" },
    { label: t("End Date"), key: "end_date" },
    { label: t("Days"), key: "number_of_days" },
    { label: t("Approved by"), key: "approved_rejected_by" },
    { label: t("Rejected by"), key: "approved_rejected_by" },
    { label: t("Description"), key: "reason" },
  ];

  const columns = [
    {
      title: t("Leave Type"),
      dataIndex: "leave_category_name",
      key: "leave_category_name",
      width: "10%",
    },
    {
      title: t("Name"),
      dataIndex: "name",
      key: "name",
      width: "10%",
    },
    {
      title: t("Department"),
      dataIndex: "department_name",
      key: "department_name",
      width: "10%",
    },
    {
      title: t("Start Date"),
      dataIndex: "start_date",
      key: "start_date",
      width: "10%",
      render: (_, record) => {
        if (
          record.new_start_date === "null" ||
          record.new_start_date === "" ||
          record.new_start_date === null
        ) {
          return moment(record.start_date).format("DD MMM YYYY");
        } else {
          return moment(record.new_start_date).format("DD MMM YYYY");
        }
      },
    },
    {
      title: t("Start Day"),
      dataIndex: "start_date",
      key: "start_date",
      width: "10%",
      render: (_, record) => {
        if (
          record.new_start_date === "null" ||
          record.new_start_date === "" ||
          record.new_start_date === null
        ) {
          return moment(record.start_date).format("dddd");
        } else {
          return moment(record.new_start_date).format("dddd");
        }
      },
    },
    {
      title: t("End Date"),
      dataIndex: "end_date",
      key: "end_date",
      width: "10%",
      render: (_, record) => {
        if (
          record.new_end_date === "null" ||
          record.new_end_date === "" ||
          record.new_end_date === null
        ) {
          return moment(record.end_date).format("DD MMM YYYY");
        } else {
          return moment(record.new_end_date).format("DD MMM YYYY");
        }
      },
    },
    {
      title: t("End Day"),
      dataIndex: "end_date",
      key: "end_date",
      width: "10%",
      render: (_, record) => {
        if (
          record.new_end_date === "null" ||
          record.new_end_date === "" ||
          record.new_end_date === null
        ) {
          return moment(record.end_date).format("dddd");
        } else {
          return moment(record.new_end_date).format("dddd");
        }
      },
    },
    {
      title: t("Days"),
      dataIndex: "number_of_days",
      key: "number_of_days",
      width: "10%",
      render: (_, record) => {
        if (
          record.new_number_of_days === null ||
          record.new_number_of_days === "" ||
          record.new_number_of_days === "null"
        ) {
          return record.number_of_days;
        } else {
          return record.new_number_of_days;
        }
      },
    },
    {
      title: t("Reliever Name"),
      dataIndex: "relievername",
      key: "relievername",
      width: "10%",
      render: (text) => {
        return text ? text : "-";
      },
    },
  ];

  if (leaveStatusId === "5") {
    columns.push({
      title: t("Approved by"),
      dataIndex: "approved_rejected_byName",
      key: "approved_rejected_byName",
      width: "10%",
    });
  }

  if (leaveStatusId === "6") {
    columns.push(
      {
        title: t("Rejected by"),
        dataIndex: "approved_rejected_byName",
        key: "approved_rejected_byName",
        width: "10%",
      },
      {
        title: t("Decline Reason"),
        dataIndex: "decline_reason",
        key: "decline_reason",
        width: "10%",
        className: "normal-column",
        render: (reason) => <ViewMore value={reason} />,
      }
    );
  } else {
    columns.push({
      title: t("Description"),
      dataIndex: "reason",
      key: "reason",
      width: "30%",
      className: "normal-column",
      render: (reason) => <ViewMore value={reason} />,
    });
  }

  const data2 = leaveList?.filter((val) => {
    if (
      val?.having_cancel_request === "0" ||
      val?.having_cancel_request === ""
    ) {
      return val;
    }
  });

  useEffect(() => {
    getLeaveList();
  }, [
    userRoleId,
    filterState.end_date,
    filterState.month,
    filterState.start_date,
    filterState.duration_type,
    filterState.status_id,
    filterState.leave_type,
  ]);

  const getLeaveList = async () => {
    return new Promise(async (resolve, reject) => {
      setLeaveList([]);
      const { status_id, start_date, duration_type, month, end_date } =
        form.getFieldsValue();
      const { startDateOfMonth, lastDateOfMonth } = getMonthDateRange(
        dateInDetail(getKenyanDateTime()).year,
        get(find(MONTH_LIST, { value: month }), "index", 0)
      );
      if (status_id) {
        setLeaveStatusId(status_id);
        setDisplayTaskLoader(true);
        const { code, leaves = [] } = await CALL_API(
          `leave-list/${ClientId}`,
          "post",
          {
            status_id: status_id === "4" ? "" : status_id,
            department_id: [userInfo?.baseDepartmentId],
            selected_role_id: userRoleId,
            start_date: getMySqlDate(
              duration_type === 2
                ? startDateOfMonth
                : duration_type === 4
                ? momentDate(addMonthinDate(getinitialdate()))
                : start_date
            ),
            end_date: getMySqlDate(
              duration_type === 2
                ? lastDateOfMonth
                : duration_type === 3
                ? weeks(7, getMySqlDate(start_date))
                : duration_type === 4
                ? momentDate(addMonthinDate(getKenyanDateTime(), 3))
                : end_date
            ),
          }
        );
        setDisplayTaskLoader(false);
        if (
          includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)
        ) {
          const filteredLeaves = leaves.filter(
            (item) => item.userid === userInfo.userid
          );
          if (form.getFieldValue("leave_type") === "") {
            setLeaveList(filteredLeaves.reverse());
          } else {
            setLeaveList(
              filter(
                filteredLeaves,
                (item) =>
                  item.leave_category_id === form.getFieldValue("leave_type")
              )
            );
          }
          resolve(filteredLeaves);
        } else {
          reject([]);
        }
      } else {
        reject();
      }
    });
  };

  const validateDateRange = (date) => {
    const endDate = moment(form.getFieldValue("end_date"));
    if (endDate < date) {
      form.setFieldsValue({ end_date: date });
    }
  };

  function weeks(days, date) {
    var newdate = new Date(date);
    newdate.setDate(date.getDate() + days);
    return newdate.toISOString().slice(0, 10);
  }

  const [fileNamelabel, setFileNameLabel] = useState("");

  const prepareCSV = async (event, done) => {
    setCSVLoader(true);
    let res = result(
      find(
        statusListFromID,
        (e) => e.status_id === form.getFieldValue("status_id")
      ),
      "status_name"
    );
    setFileNameLabel(res);
    if (leaveList.length > 0) {
      setCSVLeaveList(
        reduce(
          leaveStatusId === "4"
            ? data1
            : leaveStatusId === "5"
            ? data2
            : leaveList,
          function (result, leave) {
            if (leaveStatusId === "4") {
              result.push({
                [t("Leave Type")]: leave.leave_category_name,
                [t("Name")]: leave.name,
                [t("Department")]: leave.department_name,
                [t("Start Date")]:
                  leave.new_start_date === "null" ||
                  leave.new_start_date === "" ||
                  leave.new_start_date === null
                    ? `${moment(leave.start_date).format("Do MMM YYYY")}`
                    : `${moment(leave.new_start_date).format("Do MMM YYYY")}`,
                [t("Start Day")]:
                  leave.new_start_date === "null" ||
                  leave.new_start_date === "" ||
                  leave.new_start_date === null
                    ? `${moment(leave.start_date).format("dddd")}`
                    : `${moment(leave.new_start_date).format("dddd")}`,
                [t("End Date")]:
                  leave.new_end_date === "null" ||
                  leave.new_end_date === "" ||
                  leave.new_end_date === null
                    ? `${moment(leave.end_date).format("Do MMM YYYY")}`
                    : `${moment(leave.new_end_date).format("Do MMM YYYY")}`,
                [t("End Day")]:
                  leave.new_end_date === "null" ||
                  leave.new_end_date === "" ||
                  leave.new_end_date === null
                    ? `${moment(leave.end_date).format("dddd")}`
                    : `${moment(leave.new_end_date).format("dddd")}`,
                [t("Days")]:
                  leave.new_number_of_days === "null" ||
                  leave.new_number_of_days === null ||
                  leave.new_number_of_days === ""
                    ? leave.number_of_days
                    : leave.new_number_of_days,
                [t("Description")]: leave.reason,
                [t("Reliever Name")]: leave.relievername,
              });
            }
            if (leaveStatusId === "5") {
              result.push({
                [t("Leave Type")]: leave.leave_category_name,
                [t("Start Date")]:
                  leave.new_start_date === "null" ||
                  leave.new_start_date === "" ||
                  leave.new_start_date === null
                    ? `${moment(leave.start_date).format("Do MMM YYYY")}`
                    : `${moment(leave.new_start_date).format("Do MMM YYYY")}`,
                [t("Start Day")]:
                  leave.new_start_date === "null" ||
                  leave.new_start_date === "" ||
                  leave.new_start_date === null
                    ? `${moment(leave.start_date).format("dddd")}`
                    : `${moment(leave.new_start_date).format("dddd")}`,
                [t("End Date")]:
                  leave.new_end_date === "null" ||
                  leave.new_end_date === "" ||
                  leave.new_end_date === null
                    ? `${moment(leave.end_date).format("Do MMM YYYY")}`
                    : `${moment(leave.new_end_date).format("Do MMM YYYY")}`,
                [t("End Day")]:
                  leave.new_end_date === "null" ||
                  leave.new_end_date === "" ||
                  leave.new_end_date === null
                    ? `${moment(leave.end_date).format("dddd")}`
                    : `${moment(leave.new_end_date).format("dddd")}`,
                [t("Days")]:
                  leave.new_number_of_days === "null" ||
                  leave.new_number_of_days === "" ||
                  leave.new_number_of_days === null
                    ? leave.number_of_days
                    : leave.new_number_of_days,
                [t("Approved by")]: leave.approved_rejected_byName,
                [t("Description")]: leave.reason,
                [t("Reliever Name")]: leave.relievername,
              });
            }
            if (leaveStatusId === "6") {
              result.push({
                [t("Leave Type")]: leave.leave_category_name,
                [t("Start Date")]:
                  leave.new_start_date === "null" ||
                  leave.new_start_date === "" ||
                  leave.new_start_date === null
                    ? `${moment(leave.start_date).format("Do MMM YYYY")}`
                    : `${moment(leave.new_start_date).format("Do MMM YYYY")}`,
                [t("Start Day")]:
                  leave.new_start_date === "null" ||
                  leave.new_start_date === "" ||
                  leave.new_start_date === null
                    ? `${moment(leave.start_date).format("dddd")}`
                    : `${moment(leave.new_start_date).format("dddd")}`,
                [t("End Date")]:
                  leave.new_end_date === "null" ||
                  leave.new_end_date === "" ||
                  leave.new_end_date === null
                    ? `${moment(leave.end_date).format("Do MMM YYYY")}`
                    : `${moment(leave.new_end_date).format("Do MMM YYYY")}`,
                [t("End Day")]:
                  leave.new_end_date === "null" ||
                  leave.new_end_date === "" ||
                  leave.new_end_date === null
                    ? `${moment(leave.end_date).format("dddd")}`
                    : `${moment(leave.new_end_date).format("dddd")}`,
                [t("Days")]:
                  leave.new_number_of_days === "null" ||
                  leave.new_number_of_days === "" ||
                  leave.new_number_of_days === null
                    ? leave.number_of_days
                    : leave.new_number_of_days,
                [t("Rejected by")]: leave.approved_rejected_byName,
                [t("Decline Reason")]: leave.decline_reason,
                [t("Reliever Name")]: leave.relievername,
              });
            }
            return result;
          },
          []
        )
      );
      setTimeout(() => {
        csvLinkEl.current.link.click();
      });
    } else {
      message.error(t("No data available to download."));
    }
    setCSVLoader(false);
  };

  const filterrolelist = roleList?.filter((val) => val?.roleId === userRoleId);
  const filterdepartmentid = filterrolelist[0]?.department;
  const filterlocationid = filterrolelist[0]?.locationId;

  const filterleaves = [];
  leaveCategoryList?.forEach((item) => {
    if (item?.locationId?.length > 0) {
      if (intersection(item?.locationId, filterlocationid).length > 0) {
        filterleaves.push(item);
      }
    }
  });

  const filteruser = userList?.filter(
    (item) => item.userid === userInfo?.userid
  );
  const filtergender = filteruser[0]?.gender;
  const filteredCategoriesbygender =
    filtergender?.toLowerCase() === "male"
      ? filterleaves?.filter(
          (item) => item.eligible?.toLowerCase() !== "female"
        )
      : filterleaves?.filter((item) => item.eligible?.toLowerCase() !== "male");

  return (
    <>
      <Row className="page-title">
        <Col span={12} className="page-title-head">
          {t("Leave History")}
        </Col>
      </Row>
      <br />
      <Row className="page-title">
        <Col
          xs={24}
          sm={19}
          md={19}
          className="page-title-head"
          ref={containerRef}
        >
          <Space>
            <StyledApprovalSearchForm
              form={form}
              name="approval_form"
              layout="inline"
              initialValues={{
                duration_type: 4,
                month: dateInDetail(getKenyanDateTime()).monthName,
                status_id: "4",
                start_date: momentDate(addMonthinDate(getKenyanDateTime(), -1)),
                end_date: momentDate(addDaysinDate(getKenyanDateTime())),
                leave_type: "",
              }}
              onFinish={getLeaveList}
              onValuesChange={(changedValues) => {
                setFilterState((prev) => ({ ...prev, ...changedValues }));
              }}
            >
              <Form.Item
                name="status_id"
                rules={[{ required: true, message: "" }]}
              >
                <Select
                  placeholder={t("Select...")}
                  items={statusListFromID}
                  fieldNames={{ label: "status_name", value: "status_id" }}
                  options={statusListFromID?.map((item) => {
                    return { ...item, status_name: t(item?.status_name) };
                  })}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>

              <Form.Item
                name="duration_type"
                rules={[{ required: true, message: "" }]}
              >
                <Select
                  placeholder={t("Select...")}
                  options={APPROVAL_FILTER_TYPES.map((item) => ({
                    ...item,
                    label: t(item.label),
                  }))}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>

              <Form.Item className="outer-form" shouldUpdate>
                {({ getFieldValue }) => {
                  const duration_type = getFieldValue("duration_type");
                  return duration_type === 1 ? (
                    <>
                      <Row>
                        <Col ref={containerRef}>
                          <Form.Item
                            name="start_date"
                            rules={[
                              () => ({
                                validator(rule, value) {
                                  const date = moment(value);
                                  return date.isValid()
                                    ? Promise.resolve()
                                    : Promise.reject();
                                },
                              }),
                            ]}
                          >
                            <DatePicker
                              placeholder={t("Start date")}
                              format="DD-MM-YYYY"
                              onChange={validateDateRange}
                              allowClear={false}
                              getPopupContainer={() => containerRef.current}
                            />
                          </Form.Item>
                        </Col>
                        <Col ref={containerRef}>
                          <Form.Item
                            name="end_date"
                            rules={[
                              () => ({
                                validator(rule, value) {
                                  const date = moment(value);
                                  return date.isValid()
                                    ? Promise.resolve()
                                    : Promise.reject();
                                },
                              }),
                            ]}
                          >
                            <DatePicker
                              placeholder={t("End date")}
                              format="DD-MM-YYYY"
                              onChange={validateDateRange}
                              allowClear={false}
                              getPopupContainer={() => containerRef.current}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  ) : duration_type === 3 ? (
                    <Form.Item
                      name="start_date"
                      rules={[
                        () => ({
                          validator(rule, value) {
                            const date = moment(value);
                            return date.isValid()
                              ? Promise.resolve()
                              : Promise.reject();
                          },
                        }),
                      ]}
                    >
                      <DatePicker
                        placeholder={t("Start date")}
                        format="DD-MM-YYYY"
                        onChange={validateDateRange}
                        allowClear={false}
                        getPopupContainer={() => containerRef.current}
                      />
                    </Form.Item>
                  ) : duration_type === 2 ? (
                    <Form.Item
                      name="month"
                      rules={[{ required: true, message: "" }]}
                    >
                      <Select
                        placeholder={t("Select...")}
                        options={MONTH_LIST}
                        getPopupContainer={() => containerRef.current}
                      />
                    </Form.Item>
                  ) : (
                    ""
                  );
                }}
              </Form.Item>

              <Form.Item name="leave_type">
                <Select
                  showSearch
                  placeholder={t("Search leave type")}
                  name="leave_type"
                  optionFilterProp="leave_category_name"
                  filterOption={(input, option) =>
                    option.leave_category_name
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  filterSort={(optionA, optionB) => {
                    optionA.leave_category_name.localeCompare(
                      optionB.leave_category_name
                    );
                  }}
                  options={concat(
                    {
                      leave_category_id: "",
                      leave_category_name: t("All Categories"),
                    },
                    filteredCategoriesbygender
                  )}
                  fieldNames={{
                    label: "leave_category_name",
                    value: "leave_category_id",
                  }}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
            </StyledApprovalSearchForm>
          </Space>
        </Col>
        <Col
          xs={{ order: 1, span: 24 }}
          lg={{ order: 2, span: 4 }}
          className="align-right"
        >
          <ButtonOutlined onClick={prepareCSV}>
            {CSVloader ? t("Generating CSV file...") : t("Export CSV file")}
          </ButtonOutlined>
          <CSVLink
            header={CSVHeaders}
            data={CSVLeaveList}
            filename={`myleave-list-${fileNamelabel}.csv`}
            asyncOnClick={true}
            ref={csvLinkEl}
          />
        </Col>
      </Row>
      <Spin spinning={displayTaskLoader}>
        <StyledTable
          dataSource={
            leaveStatusId === "4"
              ? data1
              : leaveStatusId === "5"
              ? data2
              : leaveList
          }
          columns={columns}
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="user_leave_id"
        />
      </Spin>
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  statusListFromID: getStatusListFromID(state, ["4", "5", "6"]),
  selectedDepartmentId: getSelectedDepartmentId(state),
  userInfo: getUserInfo(state),
  leaveCategoryList: getLeaveCategoryList(state),
  ClientId: getClientid(state),
  userList: getUserList(state),
  roleList: getRoleList(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateProcessingModal: toggleProcessingModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null
)(Myleavereport);
